<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <v-dialog v-model="dialogKYCPending" persistent max-width="400px">
      <v-card>
        <v-toolbar dark dense class="elevation-0" color="primary">
          <div>Verification Pending</div>
        </v-toolbar>
        <v-card-text class="pb-0 mt-4">
          <v-card class="elevation-0" align="center">
            <v-img max-width="100px" src="@/assets/file.png"></v-img>
            <div align="center" class="font-weight-bold mt-4">Your Verification Is Pending.</div>
          </v-card>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn small class="borderRadius text-capitalize" color="primary" outlined @click="$router.push('/')"><v-icon small class="mr-1">mdi-exit-to-app</v-icon>Logout</v-btn>
          <v-btn small class="borderRadius text-capitalize mr-2" color="primary" :loading="loading" @click="dialogKYCPendingEmit(2)"><v-icon small class="mr-1">mdi-refresh</v-icon>Refresh</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Snackbar from "@/components/Extras/Snackbar.vue";
export default {
  props: {
    dialogKYCPending: Boolean,
    StoreObj: Object,
  },
  components: {
    Snackbar,
  },
  data: () => ({
    count: 3,
    Toggle: 0,
    logoutInterval: -1,

    loading: false,
    SnackBarComponent: {},
  }),
  mounted() {},
  methods: {
    dialogKYCPendingEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
  },
};
</script>
